<template>
    <v-container fluid class="pa-0 ma-0">

        <tools-drawer
            ref="tools"
            :visible="!!vc && !hasNotArrive"
            :event="vc && vc.schedule_event.full_entity"
        />

        <v-layout wrap>

            <v-flex xs12 text-xs-center v-if="!vc" class="mt-3">
                <v-img :src="require('@/assets/img/logo.png')" width="200" cover class="mx-auto"/>
            </v-flex>

            <!-- LOGIN -->
            <v-flex xs12 md6 offset-md3 lg4 offset-lg4 px-auto>
                <v-layout wrap>

                    <v-flex xs12 text-xs-center v-if="!!error">
                        <v-alert class="pa-4" :value="true" style="border-radius: 10px">
                            {{ error }}
                            <div v-if="unauthorized">
                                <v-btn @click="reset" small class="mt-3" round>Intentar de nuevo</v-btn>
                            </div>
                        </v-alert>
                    </v-flex>

                    <template>
                        <v-scale-transition>
                            <v-flex xs12 v-if="!showAppointment">
                                <client-login @success="onLoginSuccess" :auto-login="paymentReturn"/>
                            </v-flex>
                        </v-scale-transition>
                    </template>
                </v-layout>
            </v-flex>

            <template v-if="showAppointment">

                <v-flex v-if="loadingEvent" xs12 text-xs-center class="loading-container">
                    <v-progress-circular color="black" indeterminate width="1" size="90">
                        <v-icon size="30" color="black">far fa-calendar-minus</v-icon>
                    </v-progress-circular>
                </v-flex>

                <v-scale-transition>
                    <v-flex mt-4 pt-4 xs12 lg10 offset-lg1 xl8 offset-xl2 px-3 v-show="!loadingEvent" justify-center
                            align-center text-xs-center>

                        <template v-if="!!vc">
                            <template>
                                <video-call-client-config @done="onConfigDone" v-if="hasNotArrive" :vc="vc"/>

                                <template v-else>
                                    <v-card flat color="secondary" class="kim-card mx-auto pa-0">

                                        <v-card-title class="pt-1 pb-0 px-1 ma-0">
                                            <v-chip outline dark color="white">
                                                <v-icon class="mr-2" size="16">fa-user</v-icon>
                                                {{ vc.specialist.name }}
                                            </v-chip>
                                            <v-chip outline dark color="white">
                                                <v-icon class="mr-2" size="16">fa-clock</v-icon>
                                                {{ appointmentDate }}
                                            </v-chip>
                                            <v-spacer></v-spacer>
                                            <v-btn small fab outline dark @click="showDocs">
                                                <v-icon>fa-paperclip</v-icon>
                                            </v-btn>
                                        </v-card-title>

                                        <v-card-text class="pt-1 pb-0 px-2">

                                            <div v-if="isEnded">
                                                <v-layout class="justify-center align-center">

                                                    <v-flex xs12 py-4>
                                                        <v-sheet height="200" color="transparent"
                                                                 class="align-center mt-4">
                                                            <div class="title white--text font-weight-regular py-4">Esta
                                                                cita ha finalizado
                                                            </div>
                                                        </v-sheet>
                                                    </v-flex>

                                                </v-layout>
                                            </div>

                                            <template v-else>

                                                <kim-meet-client
                                                    :user="{displayName: vc.client.first_name || defaultUser}"
                                                    :room-id="roomId"
                                                    :height="530"
                                                    :controls="['camera', 'microphone', 'chat', 'desktop', 'fullscreen', 'settings', 'tileview']"
                                                />

                                            </template>

                                        </v-card-text>

                                        <v-card-actions></v-card-actions>

                                    </v-card>
                                </template>
                            </template>

                        </template>

                        <v-card v-if="notFound" max-width="600px" flat color="transparent" class="mx-auto">
                            <v-img :src="require(`@/assets/img/appointment_not_found.png`)" width="100%"/>
                            <div style="max-width: 350px"
                                 class="title font-weight-light mb-3 kim-card translucent py-2 mx-auto">
                                Cita no encontrada...
                            </div>
                        </v-card>
                    </v-flex>
                </v-scale-transition>
            </template>

        </v-layout>
    </v-container>
</template>

<script>

import {ApiUtils} from '@/utils/ApiUtils'
import {ARRIVED_STATUS_ID, ATTENDED_STATUS_ID} from '@/utils/ScheduleEvent'
import {mapMutations} from 'vuex'
import {subscribeToPrivateChannelEvents, leaveChannel} from '@/utils/Sockets'

export default {
    components: {
        KimMeetClient: () => import('@/components/common/webRTC/KimMeetClient'),
        VideoCallClientConfig: () => import('@/components/appointments/videocall/VCClientConfig'),
        ClientLogin: () => import('@/components/common/ClientLogin'),
        ToolsDrawer: () => import('@/components/appointments/videocall/ToolsDrawer')
    },
    data() {
        return {
            showAppointment: false,
            loadingEvent: true,
            vc: null,
            error: '',
            errorCode: 0
        }
    },
    computed: {
        unauthorized() {
            var vm = this
            return vm.errorCode === 401
        },
        notFound() {
            var vm = this
            return vm.errorCode === 404
        },
        paymentReturn() {
            var vm = this
            const paymentResponse = vm.$route.query.paymentResponse
            return paymentResponse === 'return'
        },
        roomId() {
            return this.$route.params.callId
        },
        hasNotArrive() {
            var vm = this
            return !!vm.vc && vm.vc.schedule_event.status.id < ARRIVED_STATUS_ID
        },
        isEnded() {
            var vm = this
            return !!vm.vc && vm.vc.schedule_event.full_entity.event_status_id === ATTENDED_STATUS_ID
        },
        appointmentDate() {
            var vm = this
            if (!vm.vc) return ''
            const event = vm.vc.schedule_event
            return vm.$moment(`${event.date} ${event.time}`).format('ddd D MMMM - HH:mm') + ' hrs.'
        },
        defaultUser() {
            return 'Usuario ' + process.env.VUE_APP_NAME
        }
    },
    methods: {
        ...mapMutations(['showSnackBar']),
        reset() {
            var vm = this
            vm.showAppointment = false
            vm.error = ''
            vm.errorCode = 0
        },
        showDocs() {
            var vm = this
            vm.$refs.tools.showDocsManager()
        },
        onLoginSuccess() {
            var vm = this
            vm.getAppointment()
            vm.showAppointment = true
        },
        onConfigDone() {
            this.getAppointment()
        },
        onAttentionEnd({event}) {
            var vm = this
            if (vm.vc) {
                vm.vc.schedule_event.full_entity = event
            }
        },
        async getAppointment() {
            var vm = this

            vm.error = ''
            vm.errorCode = 0

            vm.loadingEvent = true
            const response = await ApiUtils.makeGet(`appointments/video/${vm.roomId}`)
            vm.loadingEvent = false

            if (!response.ok) {
                const json = await response.json()
                vm.error = json.message || 'Ocurrió un error intentando cargar la cita'
                vm.errorCode = json.code
                return
            }

            const json = await response.json()
            vm.vc = json.result

        }
    },
    beforeDestroy() {
        var vm = this
        if (!!vm.vc) {
            leaveChannel(`appointment.${vm.vc.schedule_event.full_entity.id}`)
        }
    },
    watch: {
        vc(val) {
            var vm = this
            console.log('vc', val)
            if (val) {
                subscribeToPrivateChannelEvents(`appointment.${val.schedule_event.full_entity.id}`, {
                    'ClientAttentionEnd': vm.onAttentionEnd
                })
            }
        }
    }
}
</script>

<style>
.loading-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}
</style>